export const COMPETITORS_DROPDOWN_BUTTON_TEXT = "activation.setup.competitors.step.ai.comp.dropdown.button";
